import CoefAnimation from '../animations/coefficient/CoefAnimation';
import random from '../helpers/randomNum';

export default function nextStep() {
  const { x, y, r } = this.board[this.row][this.column];
  if (this.movePath.length === 0) {
    const anim = new CoefAnimation(x, y, r, this.vd, this.ctx, this.coef);

    this.anims.push(anim);
    setTimeout(() => {
      this.anims.shift();
      this.removeBall();
    }, 200);
    this.hide = true;
    this.handleFinish(this.coef, this.ballWin);
    return;
  }
  // Ball starting coordinates
  this.starting(this.ball.x, this.ball.y);

  let direction = 'nextRow';

  if (
    (this.movePath[0] === '1' && this.movePath[1] === '0') ||
    (this.movePath[0] === '0' && this.movePath[1] === '1')
  ) {
    this.sameRowOn.push(this.row + 1);
  }
  if (this.sameRowOn.includes(this.row)) {
    direction = 'sameRow';
    this.sameRowOn = this.sameRowOn.filter((row) => row !== this.row);
  }
  let rand = random(1, 100);
  if (
    (this.movePath[0] === '1' && this.movePath[1] === '1') ||
    (this.movePath[0] === '0' && this.movePath[1] === '0')
  ) {
    if (rand >= 1 && rand <= 35) {
      direction = 'afterNextRow';
    }
    if (rand > 35 && rand <= 100) {
      direction = 'nextRow';
    }
  }

  if (this.startingAngle > 85 && this.startingAngle < 95) {
    if (rand > 30 && rand <= 50) {
      direction = 'samePin';
    }
  }

  this.nextDirection(direction);
}
